import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './plugins/axios';
import moment from 'moment-timezone';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import vNoAutofill from './directives/vNoAutofill';
import vMobileCards from './directives/vMobileCards';
import './directives/mobileCards.css';

// Apply saved theme before mount to prevent flash
if (localStorage.getItem('nc-theme') === 'light') {
  document.documentElement.classList.add('theme-light');
  document.documentElement.style.backgroundColor = '#f8fafc';
  document.body && (document.body.style.backgroundColor = '#f8fafc');
} else {
  document.documentElement.style.backgroundColor = '#020617';
  document.body && (document.body.style.backgroundColor = '#020617');
}

const app = createApp(App);
const pinia = createPinia();

// Глобальный обработчик ошибок
let errorModalInstance = null;
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue error:', err, info);
  if (errorModalInstance) {
    errorModalInstance.show(err);
  }
};

// Глобальный метод для показа ошибок
app.config.globalProperties.$showError = (error) => {
  if (errorModalInstance) {
    errorModalInstance.show(error);
  }
};

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$apiUrl = process.env.VUE_APP_API_URL;

app.directive('no-autofill', vNoAutofill);
app.directive('mobile-cards', vMobileCards);

app.use(pinia);
app.use(store);
app.use(router);
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 5000,
});

store.dispatch('tryAutoLogin').then(async () => {
  if (store.getters.isAuthenticated) {
    try {
      await store.dispatch('fetchUser');
    } catch (e) {
      // silent: 401 is handled by the axios interceptor
    }
  }

  const mountedApp = app.mount('#app');

  // Сохраняем ссылку на ErrorModal после монтирования
  setTimeout(() => {
    const errorModalComponent = mountedApp.$refs?.errorModal;
    if (errorModalComponent) {
      errorModalInstance = errorModalComponent;
    }
  }, 100);
});
